export default __webpack_public_path__ + "static/media/google.eeb17c00.svg";